import styled from "@emotion/styled";

export const SCMPYoutubeVideoContainer = styled.div`
  inline-size: 100%;
  block-size: auto;

  aspect-ratio: 16 / 9;
`;
